module.exports = __webpack_public_path__ + "static/img/PVC_Img2.8aa7c3e6.jpg";